import { DEFAULT_VERSION } from './consts';
/**
 * Transform identities structure by version - all identitites
 */
export const structureIdentitiesByVersion = (identities, version) => {
    const output = { identities: {}, version: DEFAULT_VERSION };
    switch (version) {
        case DEFAULT_VERSION:
            output.identities = identities;
            break;
        default:
            output.identities = identities;
    }
    return output;
};
